import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./DateForm";
import {showDatePicker} from "../../actions/ViewActions";
import {cancelChangePackageDeliveryStatusPickedUp} from "../../actions/ShippingApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {simpleDateFormat} from "../../lib/DateFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "pickupDate");
  return errors.toJS();
}

class ChangePackageDeliveryStatusPickedUpFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      trackingNr: this.props.trackingNr,
      pickupDate: values.get("pickupDate")
    }
    return this.props.markPackageAsPickedUp(updatedValues)
      .then((response) => {
        if (response.data.markPackageAsPickedUp.errors.length <= 0) {
          this.props.cancelChangePackageDeliveryStatusPickedUp();
        } else {
          let errors = createValidationErrors(response.data.markPackageAsPickedUp.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleShowDatePicker(field, date, options) {
    this.props.showDatePicker(field, date, { disableWeekends: false });
  }

  handleCancel() {
    this.props.cancelChangePackageDeliveryStatusPickedUp();
  }

  render() {
    // let {data} = this.props;
    // if (data.loading) return <Loading />
    // if (data.error) return <GraphQLErrors error={data.error} />
    let todaysDate = simpleDateFormat(new Date());
    let initialValues = fromJS({
      pickupDate: todaysDate
    })    
    return (
      <Form
        errors={this.state.errors}
        initialValues={initialValues}
        fieldLabel="Pickup Date"
        fieldName="pickupDate"
        validate={validateForm}
        showDatePicker={this.handleShowDatePicker.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const MARK_PICKED_UP = gql`
  mutation markPackageAsPickedUp($data: ShippingMarkPackageAsPickedUpInput!) {
    markPackageAsPickedUp(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(MARK_PICKED_UP, {
    props: ({ mutate }) => ({
      markPackageAsPickedUp: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {
  cancelChangePackageDeliveryStatusPickedUp,
  showDatePicker
})(withProductQuery(ChangePackageDeliveryStatusPickedUpFormContainer));